import { Pipe, PipeTransform } from '@angular/core';
import {filter, includes, isUndefined, every, difference} from 'lodash';

@Pipe({
  name: 'filterPipe'
})
export class FilterPipePipe implements PipeTransform {

  public filteredData: any;

  transform(data: any, filtersSelected: Map<string, string[]>): any {
    const self = this;
    this.filteredData = data;
    filtersSelected.forEach((value: string[], key: string) => {
      if (key === 'franchiseAgreements_value') {
        self.filteredData = filter(self.filteredData, (d) => {
          return difference(value, d[key]).length === 0;
        });
      } else {
        self.filteredData = filter(self.filteredData, (d) => {
          return includes(value, d[key]) ? true : false;
        });
      }
    });
    return isUndefined(this.filteredData) === true ? null : this.filteredData;
  }

}
